import { render, staticRenderFns } from "./WatchLive.vue?vue&type=template&id=6dca76de&scoped=true&"
import script from "./WatchLive.vue?vue&type=script&lang=js&"
export * from "./WatchLive.vue?vue&type=script&lang=js&"
import style0 from "./WatchLive.vue?vue&type=style&index=0&id=6dca76de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dca76de",
  null
  
)

export default component.exports